import { getAppSettings } from "../AppSettings";
import { UserManagerFactory } from "../services/UserManagerFactory";
import { Client } from "./Client";

const baseUrl = getAppSettings().cmsApiHost;

function FetchWithAuthFactory(bearerToken: string) {
    function fetchWithAuth(input: RequestInfo, init?: RequestInit | undefined): Promise<Response> {
        if (!init) {
            init = {};
        }

        let initHeaders: HeadersInit = {};
        if (init.headers) {
            initHeaders = init.headers;
        }
        initHeaders['Authorization'] = 'Bearer ' + bearerToken;
        init.headers = initHeaders;

        return fetch(input, init);
    }

    return {
        fetch: fetchWithAuth
    }
}

// export function await await createApiClientWithAuth(): Client {
//     return new Client(baseUrl);
// }

export async function createApiClientWithAuth(): Promise<Client> {
    const userManager = UserManagerFactory();
    let user = await userManager.getUser();

    if (user !== null) {
        // if expired, renew token.
        if (user.expired) {
            try {
                user = await userManager.signinSilent();
            }
            catch(err) {
                console.error(err);
            }
        }

        const customFetch = FetchWithAuthFactory(user?.access_token);
        return new Client(baseUrl, customFetch);
    }

    return new Client(baseUrl);
}
